import { useTranslation } from "react-i18next";

import { Button, Menu } from "@mantine/core";
import { Link } from "@tanstack/react-router";

import { SYSTEM_COLORS } from "@/configs/colorScheme";

export const TermsMenu = () => {
  const { t } = useTranslation();
  return (
    <Menu trigger="click-hover">
      <Menu.Target>
        <Button variant="subtle" size="compact-xs" color={SYSTEM_COLORS.default}>
          {t("onboarding.tos")}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          variant="subtle"
          color={SYSTEM_COLORS.default}
          component="a"
          href="https://www.waku-robotics.com/en/terms"
          target="_blank"
        >
          {t("onboarding.tos")}
        </Menu.Item>
        <Menu.Item variant="subtle" color={SYSTEM_COLORS.default} component={Link} to="/privacy">
          {t("onboarding.pp")}
        </Menu.Item>
        <Menu.Item variant="subtle" color={SYSTEM_COLORS.default} component={Link} to="/terms-trial">
          {t("onboarding.tos-trial")}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default TermsMenu;
